import{useState as r}from"react";const t=()=>{const[e,p]=r(!1);return{popperOpen:e,togglePopperOpen:o=>{p(o)}}};export{t as usePopper};
